import { render, staticRenderFns } from "./HeroesListHero.vue?vue&type=template&id=d4832982&"
import script from "./HeroesListHero.vue?vue&type=script&lang=js&"
export * from "./HeroesListHero.vue?vue&type=script&lang=js&"
import style0 from "./HeroesListHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports